import canUse from './canUse'

const GetToken = () => (canUse() ? localStorage.getItem('TOKEN') : null)

export default GetToken
